import {ContentChild, Directive} from '@angular/core';
import {ValidatorTargetDirective} from "@core/libs";

@Directive({
  selector: '[appValidatorContainer]',
  exportAs: 'validatorContainer',
  standalone: false
})
export class ValidatorContainerDirective {
  @ContentChild(ValidatorTargetDirective) targetRef: ValidatorTargetDirective | null = null;
}
